import { useCallback, useReducer } from "react";
import {
  AddToCartModalNames,
  AddToCartModalUserInputs,
  initialState,
  reducer,
} from ".";

interface Props {
  onComplete: (
    results: AddToCartModalUserInputs,
    openModals: (modals: AddToCartModalNames[]) => void,
  ) => void;
}

const useAddToCartModals = ({ onComplete }: Props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { modalsToOpen, modalResults, activeModal } = state;

  const openModals = (modals: AddToCartModalNames[]) => {
    if (modals[0]) {
      const [firstModal, ...otherModals] = modals;
      dispatch({ type: "openModal", firstModal, otherModals });
    }
  };

  const closeModal = useCallback(() => {
    // Workaround for react-modal issue: https://github.com/reactjs/react-modal/issues/888
    document.body.classList.remove("overflow-hidden");
    document.body.removeAttribute("aria-hidden");

    dispatch({ type: "reset" });
  }, []);

  const submitModal = (result?: AddToCartModalUserInputs) => {
    const [nextModal, ...otherModals] = modalsToOpen;

    if (
      nextModal &&
      (nextModal !== "commercialUse" ||
        !result?.warranty?.skipCommercialModal) &&
      (nextModal !== "accessories" ||
        !result?.virtualGrouping?.groupMemberItemNumber ||
        result?.virtualGrouping?.hasAccessories)
    ) {
      dispatch({ type: "submitModal", nextModal, otherModals, result });
    } else {
      const allResults = { ...modalResults, ...result };
      onComplete(allResults, openModals);
      dispatch({ type: "reset" });
    }

    // Workaround for react-modal issue: https://github.com/reactjs/react-modal/issues/888
    document.body.classList.remove("overflow-hidden");
    document.body.removeAttribute("aria-hidden");
  };

  return {
    openModals,
    activeModal,
    closeModal,
    submitModal,
  };
};

export default useAddToCartModals;
